<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card v-if="provider && isFilled">

        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment_ind</md-icon>
          </div>
          <h4 class="title">
            {{ provider.name }} {{ provider.last_name }} {{ provider.mothers_last_name }}
            <span class="text-bold">
              ({{ provider.provider_number }})
            </span>
            <span class="status" :class="providerClass">
              {{ provider.status.name }}
            </span>
          </h4>
        </md-card-header>

        <md-card-content>
          <tabs :options="{ useUrlFragment: false }">
            <tab name="Información general">
              <div class="md-layout">
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Tipo de proveedor </p>
                  <p> {{ provider.provider_type[0].name }} </p>
                </div>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Giro empresarial </p>
                  <p> {{ provider.core_business[0].name }} </p>
                </div>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Nombre comercial </p>
                  <p> {{ provider.commercial_name }} </p>
                </div>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Fecha de registro </p>
                  <p> {{ provider.add_date | shortDate }} </p>
                </div>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Capacidad </p>
                  <p> {{ provider.capacity }} </p>
                </div>
                <div v-if="provider.does_bill"
                  class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> RFC </p>
                  <p> {{ provider.rfc }} </p>
                </div>
                <div v-if="provider.does_bill"
                  class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Zona de facturación </p>
                  <p v-if="provider.bill_zone"> {{ provider.bill_zone.name }} </p>
                  <p v-else class="text-danger">
                    No se pudo cargar la zona de facturación.
                  </p>
                </div>
              </div>
              <div class="md-layout">
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Resico
                    <md-icon class="md-size-1x green" v-if="provider.resico">
                      check_circle
                    </md-icon>
                    <md-icon class="md-size-1x red" v-else>
                      cancel
                    </md-icon>
                  </p>
                </div>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> 4%
                    <md-icon class="md-size-1x green" v-if="provider.retention_four_percent">
                      check_circle
                    </md-icon>
                    <md-icon class="md-size-1x red" v-else>
                      cancel
                    </md-icon>
                  </p>
                </div>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> 8%
                    <md-icon class="md-size-1x green" v-if="provider.retention_eight_percent">
                      check_circle
                    </md-icon>
                    <md-icon class="md-size-1x red" v-else>
                      cancel
                    </md-icon>
                  </p>
                </div>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Exento de IVA
                    <md-icon class="md-size-1x green" v-if="provider.tax_free">
                      check_circle
                    </md-icon>
                    <md-icon class="md-size-1x red" v-else>
                      cancel
                    </md-icon>
                  </p>
                </div>

              </div>

              <md-card v-for="(address, index) in provider.profile.address" :key="index">
                <md-card-header class="md-card-header-icon md-card-header-green">
                  <h4 class="title"> Dirección </h4>
                </md-card-header>
                <md-card-content>
                  <div class="md-layout">
                    <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                      <p class="title"> Calle </p>
                      <p> {{ address.street }} </p>
                    </div>
                    <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                      <p class="title"> Número interior </p>
                      <p> {{ address.no_int != 0 ? address.no_int : 'N/A' }} </p>
                    </div>
                    <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                      <p class="title"> Número exterior </p>
                      <p> {{ address.no_ext }} </p>
                    </div>
                    <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                      <p class="title"> Colonia </p>
                      <p> {{ address.colony }} </p>
                    </div>
                    <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                      <p class="title"> Código postal </p>
                      <p> {{ address.postal_code }} </p>
                    </div>
                    <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                      <p class="title"> Teléfono </p>
                      <p> {{ provider.profile.phone }} </p>
                    </div>
                    <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                      <p class="title"> Extensión </p>
                      <p> {{ provider.profile.phone_ext }} </p>
                    </div>
                    <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                      <p class="title"> Celular </p>
                      <p> {{ provider.profile.cellphone }} </p>
                    </div>
                  </div>
                </md-card-content>
              </md-card>

              <div class="md-layout">
                <hr>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Tiene vehículo
                    <md-icon class="md-size-1x green" v-if="provider.has_vehicle">
                      check_circle
                    </md-icon>
                    <md-icon class="md-size-1x red" v-else>
                      cancel
                    </md-icon>
                  </p>
                </div>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Tiene herramientas
                    <md-icon class="md-size-1x green" v-if="provider.has_tools">
                      check_circle
                    </md-icon>
                    <md-icon class="md-size-1x red" v-else>
                      cancel
                    </md-icon>
                  </p>
                </div>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> Tiene celular
                    <md-icon class="md-size-1x green" v-if="provider.has_cellphone">
                      check_circle
                    </md-icon>
                    <md-icon class="md-size-1x red" v-else>
                      cancel
                    </md-icon>
                  </p>
                </div>
                <div class="md-layout-item md-large-size-25 md-medium-size-25 md-small-size-50">
                  <p class="title"> ¿Factura?
                    <md-icon class="md-size-1x green" v-if="provider.does_bill">
                      check_circle
                    </md-icon>
                    <md-icon class="md-size-1x red" v-else>
                      cancel
                    </md-icon>
                  </p>
                </div>
              </div>
            </tab>

            <tab name="Datos bancarios">
              <div class="md-layout" v-if="Object.keys(provider.account).length !== 0">
                <div class="md-layout-item md-medium-size-100 md-small-size-100">
                  <p class="title"> Beneficiario </p>
                  <p> {{ provider.commercial_name }} </p>
                </div>
                <div class="md-layout-item md-medium-size-25 md-small-size-50">
                  <p class="title"> Banco </p>
                  <p> {{ provider.account.bank.short_name }} </p>
                </div>
                <div class="md-layout-item md-medium-size-25 md-small-size-50">
                  <p class="title"> Número de cuenta </p>
                  <p> {{ provider.account.account_number }} </p>
                </div>
                <div class="md-layout-item md-medium-size-25 md-small-size-50">
                  <p class="title"> CLABE </p>
                  <p> {{ provider.account.clabe }} </p>
                </div>
                <div class="md-layout-item md-medium-size-25 md-small-size-50">
                  <p class="title"> Número de tarjeta </p>
                  <p> {{ provider.account.card_number }} </p>
                </div>
              </div>
              <div v-else>
                <h2> El proveedor no tiene una cuenta asociada </h2>
              </div>
            </tab>

            <tab name="Archivos">
              <div class="md-layout" v-if="Object.keys(provider.files).length !== 0">
                <div v-for="file of provider.files" :key="file.id"
                  class="md-layout-item md-medium-size-100 md-small-size-100">
                  <p class="title"> {{ file.file_type.name }} </p>
                  <p>
                    <a :href="file.file">
                      <md-icon class="md-size-4x green">description</md-icon>
                    </a>
                  </p>
                </div>
              </div>
              <div v-else>
                <h2> El proveedor no tiene archivos asociados </h2>
              </div>
            </tab>

            <tab name="Evaluación"><h3>Próximamente</h3></tab>
            <tab name="Bitácora"><h3>Próximamente</h3></tab>
          </tabs>
        </md-card-content>
      </md-card>
    </div>
  </div>
</template>

<script>
  import catalogService from '@/services/catalog'
  import { assetURL } from '@/utils'

  const providerClasses = {
    ['A prueba']: 'blue',
    ['Activo']: 'green',
    ['Condicionado']: 'orange',
    ['Bloqueado']: 'red',
  }

  export default {
    name: 'ProviderDetails',
    data() {
      return {
        id: this.$route.params.id,
        provider: null,
      }
    },
    mounted() {
      catalogService.fetch(`providers/${this.id}`)
        .then(response => {
          const { files, ...provider} = response 
          files.map(f => {
            f.file = assetURL(f.file);
          })
          this.provider = {...provider, files} 
        })
    },
    computed: {
      isFilled() {
        return Object.keys(this.provider).length !== 0
      },
      providerClass () {
        const { provider } = this
        if (!provider) {
          return ''
        }
        return providerClasses[provider.status]
      }
    },
  }
</script>

<style lang="css" scoped>
    .blue { color: blue !important }
    .green { color: green !important }
    .orange { color: orange !important }
    .red { color: red !important }
</style>



// WEBPACK FOOTER //
// src/pages/Providers/ProviderDetails.vue